import { shallowEqual, useSelector } from 'react-redux'
import { AsideMenuItem } from '../AsideMenuItem'
import { RootState } from '../../../../../setup'
import { UserModel } from '../../../../../app/modules/auth/models/UserModel'

export function MenuTeam() {
  const user = useSelector<RootState>(({ auth }) => auth.user, shallowEqual) as UserModel
  const modules = user?.teamModules || []

  const canProfile = modules.includes('profile')
  const canExperiences = modules.includes('experiences')
  const canMastermind = modules.includes('mastermind')

  return (
    <div className='nb-aside-content'>
      <div className='nb-menu-section'>
        <div className='nb-menu-section-header'>
          <span className='nb-menu-section-title'>MY ACCOUNT</span>
        </div>
        <div className='nb-menu-section-content'>
          {canProfile && (
            <AsideMenuItem to='/biography?option=bio' title='MY PROFILE' showIcon={true} icon='/media/svg/nobilis/user_nb-gray.svg' />
          )}
        </div>
      </div>

      <div className='nb-menu-section'>
        <div className='nb-menu-section-header'>
          <div className='separator_menu'></div>
          <span className='nb-menu-section-title'>MY HOSTINGS</span>
        </div>
        <div className='nb-menu-section-content'>
          {canExperiences && (
            <AsideMenuItem to='/user/my-experience' title='MY EXPERIENCES' showIcon={true} icon='/media/svg/nobilis/exp_nb.svg' />
          )}
          {canMastermind && (
            <AsideMenuItem to='/my-mastermind-circles' title='MY MASTERMIND CIRCLES' showIcon={true} icon='/media/svg/nobilis/my-mastermind-circles.svg' />
          )}
        </div>
      </div>
    </div>
  )
}
